// Utility functions for managing API keys from localStorage

// Default API keys (fallback)
const DEFAULT_API_KEYS = {
  PROD: 'rl-2dcbce94-b80c-4154-8f96-1289e8dc85cf',
  SANDBOX: 'rl-2dcbce94-b80c-4154-8f96-1289e8dc85cf'
};

// Load API keys from localStorage
export const loadApiKeys = () => {
  try {
    const savedKeys = localStorage.getItem('rocketlane-api-keys');
    if (savedKeys) {
      const parsedKeys = JSON.parse(savedKeys);
      // Merge with defaults to ensure we have fallback keys
      return { ...DEFAULT_API_KEYS, ...parsedKeys };
    }
  } catch (error) {
    console.error('Error loading API keys from localStorage:', error);
  }
  
  // Return default keys if nothing is saved or error occurs
  return DEFAULT_API_KEYS;
};

// Save API keys to localStorage
export const saveApiKeys = (apiKeys) => {
  try {
    localStorage.setItem('rocketlane-api-keys', JSON.stringify(apiKeys));
    return true;
  } catch (error) {
    console.error('Error saving API keys to localStorage:', error);
    return false;
  }
};

// Get API key for specific environment
export const getApiKey = (environment) => {
  const apiKeys = loadApiKeys();
  return apiKeys[environment.toUpperCase()] || apiKeys.PROD;
};

// Check if API key exists for environment
export const hasApiKey = (environment) => {
  const apiKeys = loadApiKeys();
  return !!apiKeys[environment.toUpperCase()];
};

// Get all available environments
export const getAvailableEnvironments = () => {
  const apiKeys = loadApiKeys();
  return Object.keys(apiKeys).filter(key => apiKeys[key]);
};
